import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for filtering products by Bet Shop.
 * @extends JetView
 */
export default class FilterProductsThirdByBetShopView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with ID input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"), // Localized label
                    labelPosition: 'top',
                    placeholder: _('ID'), // Localized placeholder
                },
            ],
        };

        // Center left section with ProductsThird combo
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'ProductsThird',
                    id: 'ProductsThird',
                    label: _('Producto Terceros'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                },
            ],
        };

        // Center right section with BetShop combo
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'BetShop',
                    id: 'BetShop',
                    label: _('Punto de Venta'), // Localized label
                    hidden: !devConfig.getPermAction('filterByBetShop', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByBetShop', // Custom CSS class
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                },
            ],
        };

        // Right section with IsActivate richselect
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [
                        { id: 'null', value: _('Todos') }, // Localized option
                        { id: 'A', value: _('Activado') }, // Localized option
                        { id: 'I', value: _('Inactivado') }, // Localized option
                    ],
                },
            ],
        };

        // Upper section containing the input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of columns
                },
            ],
        };

        // Buttons for clearing and consulting
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Localized button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Localized button label
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('productsThirdByBetShop:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                        $$('b1').collapse(); // Collapse the accordion
                    },
                },
            ],
        };

        // Accordion section for filters
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop', // Custom CSS class
                    collapsed: true, // Initial state of the accordion
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section], // Main content of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and loads data from the server.
     */
    init() {
        // Load ProductsThird options from the server
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetProductsThirdSelect', // API endpoint
                '',
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Show error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        $$('ProductsThird').define('options', resp.Data); // Set options for ProductsThird
                        $$('ProductsThird').refresh(); // Refresh the combo
                    },
                },
            );

        // Load BetShop options from the server
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Accounting/GetBetShopSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    $$('BetShop').define('options', resp.Data); // Set options for BetShop
                    $$('BetShop').refresh(); // Refresh the combo
                },
            });
    }
}

// FILE DOCUMENTED
